export default {"src":"/_next/static/media/slider-indicator-empty.c4cacaa5.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};